<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <!-- Cabeçalho -->
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium mb-2 d-flex align-center">
          <span class="flex-grow-1">{{ localAula.tipo_de_aula }}</span>
          <v-btn icon @click="localDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <!-- Detalhes da Aula -->
    <v-list dense>
      <!-- Professor -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Professor (a)</v-list-item-title>
          <v-list-item-subtitle>
            {{ localAula.professor?.nome || "Sem professor" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Data -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Data</v-list-item-title>
          <v-list-item-subtitle class="d-flex align-center">
            <v-icon small class="mr-1">mdi-calendar</v-icon>
            <span>{{ localAula.data_formatada }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Horário -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Horário</v-list-item-title>
          <v-list-item-subtitle>
            {{ localAula.horario ? localAula.horario.descricao : "- - -" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Conteúdo e Metodologia -->
      <div v-for="(item, index) of $constants.listCamposAulasLancadas" :key="index">
        <v-list-item
          v-if="
            localAula[index] &&
            index !== 'campos_de_experiencias' &&
            index !== 'eixos' &&
            index !== 'estrategias'
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item }}</v-list-item-title>
            <v-list-item-subtitle>
              <div v-html="formatTexto(localAula[index])"></div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
      <!-- Situação -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Situação</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip label :color="localAula.color">
              {{ localAula.descricaoSituacao }}
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Motivo -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Motivo</v-list-item-title>
          <v-list-item-subtitle>
            {{ localAula.motivo || "Sem motivo." }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!-- Atestado (PDF) -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Atestado (PDF)</v-list-item-title>
          <v-list-item-subtitle>
            <a
              v-if="
                localAula.atestado_path &&
                localAula.atestado_path.includes('.pdf') &&
                localAula.option === 'FALTA COM ATESTADO'
              "
              :href="localAula.atestado_path"
              target="_blank"
              >Visualizar</a
            >
            <span v-else>Não existem PDFs anexados.</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aula: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatarData(aula) {
      if (aula.tipo_de_aula === "Reposição") {
        return `Data original: ${aula.data_formatada} <br /> Data de reposição: ${aula.data_reposicao_formatada}`;
      }
      return `Data: ${aula.data_formatada}`;
    },
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, "");
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, "");
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>");
      return textoFormatado.trim() || "- - -";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    localAula() {
      return this.aula;
    },
  },
  data() {
    return {
      localDrawer: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: #f8f9fa;
}
.v-list-item {
  &-icon {
    margin-right: 16px;
  }
  &-subtitle {
    font-size: 0.9rem;
  }
}
.v-chip {
  font-size: 0.9rem;
}
.v-card-actions {
  padding: 16px;
}
</style>
